import { useFlags } from "launchdarkly-react-client-sdk";

export function usePlainNoteEditor(): boolean {
  const { configureWebRichTextEditorOptOut } = useFlags();
  return !!configureWebRichTextEditorOptOut;
}
